import { useQuery } from "@tanstack/react-query";
import { UniqueCheckResponse } from "tng-address-collection-shared/types/apiTypes.ts";
import { useAuthentication } from "../auth/useAuthentication.ts";
import { queryKeys } from "./queryKeys.ts";

export interface CheckEmail {
  isUnique: boolean;
  cardInOtherProject?: { cardId: string; responsibleProjectId: string };
  isLoading: boolean;
  isError: boolean;
}

export const useCheckEmail = (projectId: string, email: string): CheckEmail => {
  const { getToken } = useAuthentication();

  const { data, isLoading, isError } = useQuery({
    queryKey: queryKeys.emailUniqueness(projectId, email),
    queryFn: async ({ signal }): Promise<UniqueCheckResponse> => {
      const token = await getToken();

      const response = await fetch(
        `/api/projects/${encodeURIComponent(projectId)}/cardUnique?email=${encodeURIComponent(email)}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
          signal,
        },
      );

      if (!response.ok) {
        throw new Error("Email uniqueness check failed");
      }

      return UniqueCheckResponse.parse(await response.json());
    },
    enabled: !!email && email.length > 0,
    retry: false,
    staleTime: 5000,
  });

  return {
    isUnique: data?.isUnique ?? true,
    cardInOtherProject: data?.cardInOtherProject,
    isLoading,
    isError,
  };
};
